import ApiService from "./ApiService";

const PendingService = {
  updatePending(data) {
    return ApiService.post(`/pending-order`, {
      orderId: data.orderId,
      medicines: data.medicines
    });
  }
};

export default PendingService;
